import styled, {keyframes} from 'styled-components';

export const ButtonsContainer = styled.div`
    display: flex;
    gap: 10px;
    justify-content: stretch;
    align-items: center;
`;

const opacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const SpinnerLayer = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    height: 50px;

    animation: ${opacity} 2s ease;
`;
